module.exports = __webpack_public_path__ + "images/Addempl.png";


//////////////////
// WEBPACK FOOTER
// ./images/Addempl.png
// module id = 1107
// module chunks = 1